import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../Dashboard";
import Login from "../component/Login";

export default function EmployeeRoutes() {
  // Using React state only (No localStorage), so it resets on page refresh and menu navigation
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  if (!isAuthenticated) {
    return <Login onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return (
    <Routes>
      <Route path="/" element={null} />

      {/* Open State */}
      <Route path="dashboard" element={<Dashboard />} />
    </Routes>
  );
}
